import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const FormUpdateEquipment = lazyLoader(
  () => import("Containers/Equipment/FormEquipment/FormUpdateEquipment")
);

export const UpdateEquipment = () => {
  return (
    <Layout>
      <FormUpdateEquipment />
    </Layout>
  );
};
